import {getTranslations} from "../../services/language.service.js";

export const EventResult = (props) => {
    const LANG = getTranslations()

    const handleKeydown = (e) => {

        if (e.key === "Tab" && e.target.dataset.index) {
            const index = parseInt(e.target.dataset.index);
            if (e.shiftKey === false) {
                // Tab forward
                e.preventDefault()
                const nextElement = document.querySelector("a[data-index='"+ (index + 1) +"']")
                if (nextElement) {
                    nextElement.focus()
                } else {
                    // Kein nächstes Element, springe zum Footer
                    document.querySelector(".um-footer a").focus()

                }
            } else {
                // Tab back
                const prevElement = document.querySelector("a[data-index='"+ (index - 1) +"']")
                if (prevElement) {
                    e.preventDefault()
                    prevElement.focus()
                }
            }
        }

    }

    const wrapHeadlinde = (headline) => {
        return headline.replace(/Teil\s+(\d+):/g, '<span class="um-nowrap">Teil $1:</span>')
    }

    return <div style={{marginBottom: "20px"}}>

        <a data-index={props.index} href={props.result.url} title={props.result.title} className={"um-sheet bg-grey um-sheet--masonry um-sheet--arrow" + (props.result.image  !== '' ? ' um-sheet--image' : '')} onKeyDown={handleKeydown}>



            {props.result.image !=='' &&
                <div className="image">
                    <img src={props.result.image} alt={props.result.title}/>
                </div>
            }


            <div className="content">
                {props.result.availabilityText !== "" &&
                    <div className="news-list-tags news-list-tags--highlight"><span>{props.result.availabilityText}</span></div>
                }
                {(props.result.category !== '' && props.siteId !== "eaa") &&
                    <div className="news-list-tags"><span>{LANG['category_' + props.result.category] ?? props.result.category}</span></div>
                }
                <div className="info">
                    {props.result.eventImplementationType !== 'Recorded Session' &&
                        props.result.date
                    }
                    {(props.result.eventImplementationType !== 'Recorded Session' && props.result.place !== '') &&
                        " |"
                    }

                    {props.result.place !== '' && <span className="news-list-category"> {props.result.place}</span>}
                    {(props.result.category !== '' && props.siteId !== "eaa") &&
                        <span className="news-list-category"> | {LANG['category_' + props.result.category] ?? props.result.category}</span>}
                    {(props.result.eventType !== '' && props.siteId === "eaa") &&
                        <span className="news-list-category"> | {props.result.eventType}</span>}
                </div>
                <div className="headline_3">
                    <span dangerouslySetInnerHTML={{__html: wrapHeadlinde(props.result.title + " " + props.result.subTitle)}}/>
                </div>

                {props.result.eventClient !== 'EAA' &&
                    <div className="text">
                        <div dangerouslySetInnerHTML={{__html: props.result.teaser}}/>
                    </div>
                }

                {(props.result.lectures.length > 0 && props.result.eventClient !== 'EAA') && <div className="news-list-lectures">{`Dozierende: `}
                    {props.result.lectures.map(lecture => lecture).join(', ')}
                </div>}

            </div>
        </a>
    </div>
}
